import React           from "react";
import ReactDOM         from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App              from "./App.js";
import { AuthProvider } from "./hooks/useAuth.js";
import "./styles/global.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
